var map = {
	"./back.png": 623,
	"./hepkarli.png": 704,
	"./hepkarliLogo.png": 129,
	"./hepsiburada.png": 34,
	"./instagram.png": 892,
	"./mail.png": 815,
	"./n11.png": 800,
	"./pazarama.png": 329,
	"./pttavm.png": 636,
	"./trendyol.png": 565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;